// Header
export const SET_HEADER_VISIBILITY = 'SET_HEADER_VISBILITY';
export const SET_HEADER_TITLE = 'SET_HEADER_TITLE';
export const SET_HEADER_DESCRIPTION = 'SET_HEADER_DESCRIPTION';
export const SET_HEADER_CONTENT = 'SET_HEADER_CONTENT';
// Header Info
export const GET_HEADER_INFO = 'GET_HEADER_INFO';
// Registry
export const GET_REGISTRY = 'GET_REGISTRY';
